'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');

var AlarmController = require('components/devices/controllers/alarm');
var AlarmOccurrenceController = require('components/devices/controllers/alarm_occurrence');
var FilterController = require('components/devices/controllers/filter');
var MapController = require('components/devices/controllers/map');
var StatsController = require('components/devices/controllers/stats');
var RankingController = require('components/devices/controllers/ranking');
var Strings = require('utils/strings');

var DevicesComponent = {};

DevicesComponent.initializeRouting = function () {
    new DevicesComponent.Router({
        controller: API,
    });
};

var appRoutes = {
    'alarm-configuration': 'showAlarmList',
    'alarm-list': 'showAlarmOccurrence',
    map: 'showDeviceMap',
    stats: 'showDeviceStats',
    ranking: 'showDeviceRanking',
    search: 'deviceFilter',
    'search?*query': 'deviceFilter',
    'link?*query': 'quickLink',
};

var API = {
    // Function 'quickLink' querys the backend for devices matching the 'query'.
    // If exactly one result is returned the resulting device is shown,
    // otherwise the search page with the query is shown.
    quickLink: function (query) {
        var filterParams = { name: query, limit: 2 };

        var isUniqueResult = function (result) {
            if (result && result.items && result.items.models) {
                return result.items.models.length === 1;
            }
            return false;
        };

        var req = App.request('device:list', {
            filter: { search_text: filterParams.name },
            filterParams: filterParams,
            wantAll: false,
        });

        $.when(req).done(function (data) {
            if (!isUniqueResult(data)) {
                // no or more than one result -> show search page
                var controller = new FilterController();
                controller.showFilter(filterParams);
                return;
            }

            // open device page
            var device = data.listResult.attributes.items[0];
            var categoryData = Consts.DeviceCategory[device.category];
            var categoryKey = categoryData.categoryKey;
            var categoryUrl = categoryData.url;
            var urlParts = window.location.href.split('/');

            window.location.replace(urlParts[0] + '//' + urlParts[2] + '/' + categoryUrl + '/' + device.id);
        });
    },

    getFilter: function () {
        AppState.saveURLParameter();
        return AppState.getURLParameter(['filter', 'tags', 'groups', 'status', 'category', 'device_groups']);
    },

    deviceFilter: function (query) {
        var controller = new FilterController();

        function parseQuery(query) {
            var result = {};
            var params = decodeURIComponent(query).split('&');

            _.each(params, function (p) {
                var sepPos = p.indexOf('=');
                if (sepPos != -1) {
                    var key = p.substring(0, sepPos);
                    var value = p.substring(sepPos + 1);

                    try {
                        value = JSON.parse(value);
                    } catch (err) {
                        // was not a json, ignore error
                    }
                    result[key] = value;
                }
            });

            return result;
        }

        if (query != undefined) {
            // query is taken from the url? -> decode
            if (typeof query === 'string') {
                query = parseQuery(query);
            }
            AppState.saveURLParameter(query, Backbone.history.fragment.split('?')[0]);
            // if we have a search query, show results immediately
            controller.showFilter(query, !$.isEmptyObject(query));
            return;
        }

        controller.showFilter(this.getFilter());
    },

    showAlarmList: function () {
        var controller = new AlarmController();
        controller.show();
    },

    showAlarmOccurrence: function () {
        var controller = new AlarmOccurrenceController();
        controller.show();
    },

    showDeviceMap: function (params) {
        var controller = new MapController();
        controller.show(typeof params == 'string' ? undefined : params);
    },

    showDeviceStats: function (query) {
        var stats = new StatsController();
        stats.show(this.getFilter());
    },

    showDeviceRanking: function (query) {
        var ranking = new RankingController();
        ranking.show();
    },

    showDeviceStatsDialog: function (request, refreshCb) {
        var stats = new StatsController();
        stats.showDialog(request, refreshCb);
    },

    createNewVirtualDevice: function () {
        var stats = new StatsController();
        stats.saveVirtualDevice({
            series: [],
            filter: {},
        });
    },
};

DevicesComponent.InstallDeviceCategories = function () {
    var buildShowFunction = function (controller, category) {
        var myController = controller;

        var result = function (id, tab, customData) {
            var c = new myController({ deviceCategory: category });
            c.showDevice(id, tab, customData);
        };

        return result;
    };

    _.each(Consts.CategoryData, function (data, categoryAlias) {
        var category = data.category;
        var compData = App.DevicesCategoryObj[category];
        if (!compData) {
            throw 'Missing record in device_component/DeviceCategories for ' + category;
        }

        // controller has to have show device method
        var dummy = new compData.controller({ deviceCategory: category });
        if (!dummy.showDevice) {
            throw 'Controller for category ' + category + ' must have showDevice function.';
        }
        dummy.checkConsistency();

        var funcName = 'show' + categoryAlias;

        // create API function
        API[funcName] = buildShowFunction(compData.controller, category);

        var url = data.url;
        url = url.substr(1, url.length);

        // register request
        App.on(category + ':show', function (id, tab, customData) {
            App.navigate(Strings.joinURL(url, id, tab));
            var f = API[funcName];
            f(id, tab, customData);
        });

        // add routes
        appRoutes[url + '(/:id)(/:tab)(/:customData)'] = funcName;
    });

    DevicesComponent.Router = App.BaseRouter.extend({
        appRoutes: appRoutes,
    });
};

App.on('device:filter', function (query) {
    App.navigate('search');
    API.deviceFilter(query);
});

App.on('alarm:list:show', function () {
    App.navigate('alarm-list');
    API.showAlarmOccurrence();
});

App.on('device:map', function (params) {
    App.navigate('map');
    API.showDeviceMap(params);
});

App.on('stats:show', function (query) {
    App.navigate('stats');
    API.showDeviceStats(query);
});

App.on('stats:dialog', function (req, refreshCb) {
    API.showDeviceStatsDialog(req, refreshCb);
});

App.on('virtual:device:new', function () {
    API.createNewVirtualDevice();
});

module.exports = DevicesComponent;
